
export { GGUSection } from "/codebuild/output/src4239905409/src/packages/shared-components/src/campaign/GGUSection.tsx"